import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

export const ChatPreview = () => {
  const [visibleStep, setVisibleStep] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setVisibleStep(1), 500), // Q1
      setTimeout(() => setVisibleStep(2), 1500), // A1
      setTimeout(() => setVisibleStep(3), 2500), // Q2
      setTimeout(() => setVisibleStep(4), 3500) // A2
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  const bubbleBase =
    "max-w-[85%] p-3 rounded-2xl text-sm transition-all duration-500 transform";
  const questionClass = cn(
    bubbleBase,
    "bg-white border border-gray-100 shadow-sm self-start translate-x-0"
  );
  const answerClass = cn(
    bubbleBase,
    "bg-[#e0f2f1] text-[#00796b] self-end text-right font-medium"
  );

  return (
    <div className="bg-gray-50/50 rounded-3xl p-2 flex flex-col gap-3 min-h-[220px] sm:min-h-[300px] border border-gray-100">
      <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 text-center">
        You'll be able to ask:
      </p>

      {visibleStep >= 1 && (
        <div
          className={cn(
            questionClass,
            "animate-in fade-in slide-in-from-left-2"
          )}
        >
          "What were my sales today?"
        </div>
      )}

      {visibleStep >= 2 && (
        <div
          className={cn(
            answerClass,
            "animate-in fade-in slide-in-from-right-2"
          )}
        >
          $425 across 12 transactions
        </div>
      )}

      {visibleStep >= 3 && (
        <div
          className={cn(
            questionClass,
            "animate-in fade-in slide-in-from-left-2"
          )}
        >
          "Which product is selling best?"
        </div>
      )}

      {visibleStep >= 4 && (
        <div
          className={cn(
            answerClass,
            "animate-in fade-in slide-in-from-right-2"
          )}
        >
          Large Pepperoni Pizza 🍕
        </div>
      )}
    </div>
  );
};
